<template>
    <div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="params.fab ? params.fab : false"
						:icon="params.fab ? false : true"
						:small="params.small ? true : false"
						:fixed="params.fixed ? true : false"
						:bottom="params.bottom ? true : false"
						:right="params.right ? true : false"
						:dark="params.dark ? true : false"
						:color="params.button_color ? params.button_color : ''"
						@click="toggleDialog(true)">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ icon }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ tooltip }}</span>
    		</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
            dense 
            :disabled="disabled"
            @click.stop="toggleDialog(true)"
            ripple>
            <v-list-item-icon>
                <v-icon style="font-size: 18px">{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ tooltip }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-dialog v-model="dialog"
            max-width="900px"
            persistent
            scrollable
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card class="flex pa-0 background-2 round-card">

                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Aggiungi Timecard</p>
                    <v-spacer></v-spacer>                        
                </v-card-title>

                <v-divider></v-divider>
                <v-card-text class="pa-0 pt-4">
                    <v-container fluid v-if="dialog">
                        <fields-generator
                            :fieldsset.sync="fieldsset"
                            :model="model"
                            ref="fieldsgenerator"
                            :selectChange="onChange"
                            :support="support"
                            @loaded="checkDefaultInput"
                        ></fields-generator>
                        <small class="pl-4">* Indica i campi obbligatori</small>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn @click="toggleDialog(false)" color="red" text>Chiudi</v-btn>
                    <v-btn color="info" text @click.native.stop="createModel()" :loading="loading">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Create from '@/components/common/Create'

    export default {
        name: 'timecard-dialog',
        extends: Create,
        props: {
            button: Object,
            buttonComponent: {type: String, default : 'v-btn'},
            params: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            disabled: Boolean,
            open: Boolean,
            defaultInput: Object,
            modelDef: {
                type: String,
                default: 'timecards'
            },

        },

        data() {
            return {
                dialog: false,
                loading: false,
                url: '',
                items: {},
                fieldsset: {'fields': []},
            }
        },

        computed: {
            icon() {
                if(this.button && this.button.params) {
                    return this.button.params.icon ? this.button.params.icon : 'mdi-alarm-plus'
                }
                return 'mdi-alarm-plus'
            },

            tooltip() {
                if(this.button && this.button.params) {
                    return this.button.params.tooltip ? this.button.params.tooltip : 'Aggiungi Timecard'
                }
                return 'Aggiungi Timecard'
            },
        },

        methods: {

            toggleDialog(value) {
                this.dialog = value
                if(value) {
                    this.$eventBusUtility.$emit('showButtonsList', false)
                }
            },
            
            createModel() {
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return this.handleValidationErrorAdvanced()
                    }

                    let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''
       
                    if(this.crudRelation) {
                        this.model[this.crudRelation.relationModelsKey] = this.relationModels
                    }

                    this.loading = true

                    this.axios.post(this.modelDef + urlWithAppend, this.model).then(response => {
                        // get body data
                        // this.model = {}
                        this.dialog = false
                        this.loading = false
                        this.$eventBusUtility.$emit('updatedTaskboard')
                        this.$eventBusUtility.$emit('refreshTable_timecards')

                    }, response => {
                        this.loading = false
                    })
                }).catch(() => {

                })
            },

        },
    }
</script>